<!-- Bandeja unificada (enviados + recibidos) — fuente única: timeline/mine -->
<div class="flex overflow-hidden bg-gray-50 dark:bg-gray-900" style="height: calc(100vh - 64px)">

  <!-- ════════════════ Panel IZQUIERDO: lista (ancho fijo) ════════════════ -->
  <div class="flex w-full shrink-0 flex-col border-r border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900 lg:w-[360px]"
       [class.hidden]="selectedKey"
       [class.lg:flex]="true">

    <!-- Cabecera + filtros -->
    <div class="shrink-0 border-b border-gray-200 dark:border-gray-800">
      <div class="flex items-center justify-between gap-2 px-4 pt-4">
        <div class="flex items-center gap-2">
          <h2 class="text-lg font-semibold text-gray-800 dark:text-white/90">Bandeja de entrada</h2>
          @if (syncing) {
          <span class="inline-flex items-center gap-1 text-[11px] text-gray-400 dark:text-gray-500">
            <span class="h-3 w-3 animate-spin rounded-full border-b-2 border-brand-500"></span>
            Actualizando…
          </span>
          }
        </div>
        <div class="flex items-center gap-1">
          <button
            type="button"
            (click)="abrirRedactar()"
            title="Redactar correo"
            class="inline-flex h-9 items-center gap-1.5 rounded-lg bg-brand-500 px-3 text-sm font-medium text-white hover:bg-brand-600">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
            </svg>
            Redactar
          </button>
          <button
            type="button"
            (click)="refrescar()"
            [disabled]="loading || syncing"
            title="Refrescar bandeja"
            class="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-gray-300 text-gray-500 hover:bg-gray-50 hover:text-gray-700 disabled:opacity-50 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-300">
            <svg class="h-4 w-4" [class.animate-spin]="loading || syncing" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
            </svg>
          </button>
          <a
            routerLink="/correo/configuracion"
            title="Conexión SMTP/IMAP"
            class="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-gray-300 text-gray-500 hover:bg-gray-50 hover:text-gray-700 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-300">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
            </svg>
          </a>
        </div>
      </div>

      <!-- Búsqueda -->
      <div class="px-4 pt-3">
        <div class="relative">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-4.35-4.35M17 10.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"></path>
            </svg>
          </span>
          <input
            type="text"
            [(ngModel)]="filtroQ"
            (ngModelChange)="onFiltroTexto()"
            placeholder="Buscar en la bandeja..."
            class="h-10 w-full rounded-lg border border-gray-300 bg-transparent pl-9 pr-4 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
          />
        </div>
      </div>

      <!-- Chips de dirección + no leídos -->
      <div class="flex flex-wrap items-center gap-1.5 px-4 py-3">
        <button
          type="button"
          (click)="setDirection('ALL')"
          class="rounded-full px-3 py-1 text-xs font-medium transition"
          [class.bg-brand-500]="directionFilter === 'ALL'"
          [class.text-white]="directionFilter === 'ALL'"
          [class.bg-gray-100]="directionFilter !== 'ALL'"
          [class.text-gray-600]="directionFilter !== 'ALL'"
          [class.dark:bg-gray-800]="directionFilter !== 'ALL'"
          [class.dark:text-gray-300]="directionFilter !== 'ALL'">
          Todos
        </button>
        <button
          type="button"
          (click)="setDirection('RECEIVED')"
          class="inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-medium transition"
          [class.bg-blue-light-500]="directionFilter === 'RECEIVED'"
          [class.text-white]="directionFilter === 'RECEIVED'"
          [class.bg-gray-100]="directionFilter !== 'RECEIVED'"
          [class.text-gray-600]="directionFilter !== 'RECEIVED'"
          [class.dark:bg-gray-800]="directionFilter !== 'RECEIVED'"
          [class.dark:text-gray-300]="directionFilter !== 'RECEIVED'">
          Recibidos
        </button>
        <button
          type="button"
          (click)="setDirection('SENT')"
          class="inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-medium transition"
          [class.bg-success-500]="directionFilter === 'SENT'"
          [class.text-white]="directionFilter === 'SENT'"
          [class.bg-gray-100]="directionFilter !== 'SENT'"
          [class.text-gray-600]="directionFilter !== 'SENT'"
          [class.dark:bg-gray-800]="directionFilter !== 'SENT'"
          [class.dark:text-gray-300]="directionFilter !== 'SENT'">
          Enviados
        </button>

        @if (noLeidosVisible) {
        <button
          type="button"
          (click)="toggleNoLeidos()"
          class="ml-auto inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-medium transition"
          [class.bg-brand-500]="soloNoLeidos"
          [class.text-white]="soloNoLeidos"
          [class.bg-gray-100]="!soloNoLeidos"
          [class.text-gray-600]="!soloNoLeidos"
          [class.dark:bg-gray-800]="!soloNoLeidos"
          [class.dark:text-gray-300]="!soloNoLeidos">
          No leídos
        </button>
        }
      </div>

      <!-- Filtro "Conversación con" (contacto o correo) -->
      <div class="relative px-4 pb-3">
        @if (convActiva) {
        <!-- Chip de conversación activa -->
        <div class="flex items-center justify-between gap-2 rounded-lg border border-brand-200 bg-brand-50 px-3 py-2 dark:border-brand-500/30 dark:bg-brand-500/10">
          <div class="flex min-w-0 items-center gap-2">
            <svg class="h-4 w-4 shrink-0 text-brand-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.86 9.86 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
            </svg>
            <span class="truncate text-xs font-medium text-brand-700 dark:text-brand-300">Conversación con: {{ convLabel }}</span>
          </div>
          <button type="button" (click)="limpiarConversacion()" title="Quitar filtro de conversación"
            class="shrink-0 rounded-md p-0.5 text-brand-500 hover:bg-brand-100 dark:hover:bg-brand-500/20">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        } @else {
        <!-- Botón para abrir el buscador -->
        <button type="button" (click)="toggleContactSearch()"
          class="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-600 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/[0.03]">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.86 9.86 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
          </svg>
          Ver conversación con…
        </button>
        }

        <!-- Dropdown de búsqueda de contacto / correo libre -->
        @if (showContactSearch && !convActiva) {
        <div class="absolute left-4 right-4 z-dropdown mt-1 rounded-lg border border-gray-200 bg-white shadow-theme-lg dark:border-gray-700 dark:bg-gray-900">
          <div class="border-b border-gray-100 p-2 dark:border-gray-800">
            <input
              type="text"
              [(ngModel)]="contactQuery"
              (ngModelChange)="onContactQueryChange()"
              (keyup.enter)="filtrarPorCorreoLibre()"
              placeholder="Nombre o correo del contacto..."
              autofocus
              class="h-9 w-full rounded-md border border-gray-300 bg-transparent px-3 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:text-white/90 dark:placeholder:text-white/30"
            />
          </div>
          <div class="max-h-64 overflow-y-auto py-1">
            @if (contactSearching) {
            <div class="flex items-center gap-2 px-3 py-2 text-xs text-gray-400">
              <span class="h-3.5 w-3.5 animate-spin rounded-full border-b-2 border-brand-500"></span>
              Buscando contactos…
            </div>
            }
            @for (c of contactResults; track c.id) {
            <button type="button" (click)="seleccionarContacto(c)"
              class="flex w-full items-center gap-2 px-3 py-2 text-left hover:bg-gray-50 dark:hover:bg-white/[0.03]">
              <div class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-50 text-[10px] font-semibold text-brand-600 dark:bg-brand-500/10 dark:text-brand-400">
                {{ (c.fullname || c.mail || '?').substring(0, 2).toUpperCase() }}
              </div>
              <div class="min-w-0">
                <p class="truncate text-sm text-gray-800 dark:text-white/90">{{ c.fullname || '(sin nombre)' }}</p>
                <p class="truncate text-xs text-gray-400 dark:text-gray-500">{{ c.mail }}</p>
              </div>
            </button>
            }
            @if (!contactSearching && contactResults.length === 0 && contactQuery.trim().length >= 2) {
            <button type="button" (click)="filtrarPorCorreoLibre()"
              class="flex w-full items-center gap-2 px-3 py-2 text-left hover:bg-gray-50 dark:hover:bg-white/[0.03]">
              <svg class="h-4 w-4 shrink-0 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
              </svg>
              <span class="truncate text-sm text-gray-700 dark:text-gray-300">Filtrar por correo "<span class="font-medium">{{ contactQuery.trim() }}</span>"</span>
            </button>
            }
          </div>
          <div class="border-t border-gray-100 p-2 text-right dark:border-gray-800">
            <button type="button" (click)="cerrarBuscadorContacto()" class="text-xs text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">Cancelar</button>
          </div>
        </div>
        }
      </div>

      <!-- Aviso no intrusivo: IMAP no conectado (igual se ven enviados/recibidos cacheados) -->
      @if (noInbox) {
      <div class="mx-4 mb-3 flex items-start gap-2 rounded-lg border border-warning-200 bg-warning-50 px-3 py-2 dark:border-warning-500/20 dark:bg-warning-500/10">
        <svg class="mt-0.5 h-4 w-4 shrink-0 text-warning-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M10.29 3.86l-7.4 12.8A2 2 0 004.6 20h14.8a2 2 0 001.71-3.34l-7.4-12.8a2 2 0 00-3.42 0z"></path>
        </svg>
        <div class="min-w-0 text-xs text-warning-700 dark:text-warning-400">
          No tienes un buzón IMAP conectado, así que solo verás correos ya guardados.
          <button type="button" (click)="irAConfiguracion()" class="font-medium underline hover:text-warning-800 dark:hover:text-warning-300">Conectar IMAP</button>
        </div>
      </div>
      }
    </div>

    <!-- Lista (scroll) -->
    <div class="flex-1 overflow-y-auto">

      <!-- Error genérico -->
      @if (errorMessage && items.length === 0) {
      <div class="m-4 rounded-lg border border-error-200 bg-error-50 p-4 dark:border-error-500/20 dark:bg-error-500/10">
        <p class="text-sm text-error-600 dark:text-error-400">{{ errorMessage }}</p>
      </div>
      }

      <!-- Cargando -->
      @if (loading) {
      <div class="flex items-center justify-center py-16">
        <div class="h-7 w-7 animate-spin rounded-full border-b-2 border-brand-500"></div>
        <span class="ml-3 text-sm text-gray-500 dark:text-gray-400">Cargando bandeja...</span>
      </div>
      }

      <!-- Vacío -->
      @if (!loading && items.length === 0 && !errorMessage) {
      <div class="flex flex-col items-center justify-center px-6 py-16 text-center">
        <svg class="mb-3 h-9 w-9 text-gray-300 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"></path>
        </svg>
        <p class="text-sm text-gray-500 dark:text-gray-400">No hay correos que coincidan.</p>
      </div>
      }

      <!-- Items (fuente única ya ordenada DESC por el backend) -->
      @if (!loading && items.length > 0) {
      <ul class="divide-y divide-gray-100 dark:divide-gray-800">
        @for (item of items; track item.key) {
        <li
          (click)="openItem(item)"
          class="group relative flex cursor-pointer gap-3 px-4 py-3 transition-colors hover:bg-gray-50 dark:hover:bg-white/[0.03]"
          [class.bg-brand-50]="selectedKey === item.key"
          [class.dark:bg-brand-500/10]="selectedKey === item.key"
          [class.border-l-4]="selectedKey === item.key"
          [class.border-l-brand-500]="selectedKey === item.key">

          <!-- Avatar + flecha de dirección -->
          <div class="relative shrink-0">
            <div class="flex h-10 w-10 items-center justify-center rounded-full text-xs font-semibold"
                 [class.bg-blue-light-50]="item.direction === 'RECEIVED'"
                 [class.text-blue-light-600]="item.direction === 'RECEIVED'"
                 [class.dark:bg-blue-light-500/10]="item.direction === 'RECEIVED'"
                 [class.dark:text-blue-light-400]="item.direction === 'RECEIVED'"
                 [class.bg-success-50]="item.direction === 'SENT'"
                 [class.text-success-700]="item.direction === 'SENT'"
                 [class.dark:bg-success-500/10]="item.direction === 'SENT'"
                 [class.dark:text-success-400]="item.direction === 'SENT'">
              {{ counterpartInitials(item) }}
            </div>
            <!-- Badge de flecha entrante/saliente -->
            <span class="absolute -bottom-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full ring-2 ring-white dark:ring-gray-900"
                  [class.bg-blue-light-500]="item.direction === 'RECEIVED'"
                  [class.bg-success-500]="item.direction === 'SENT'"
                  [title]="item.direction === 'RECEIVED' ? 'Recibido' : 'Enviado'">
              @if (item.direction === 'RECEIVED') {
              <!-- Flecha entrante ↙ -->
              <svg class="h-3 w-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M11 17l-4-4m0 0l4-4m-4 4h11"></path>
              </svg>
              } @else {
              <!-- Flecha saliente ↗ -->
              <svg class="h-3 w-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M7 17L17 7m0 0H9m8 0v8"></path>
              </svg>
              }
            </span>
          </div>

          <div class="min-w-0 flex-1">
            <div class="flex items-center justify-between gap-2">
              <p class="truncate text-sm text-gray-800 dark:text-white/90"
                 [class.font-bold]="!item.read" [class.font-medium]="item.read">
                <span class="text-xs font-normal text-gray-400 dark:text-gray-500">{{ item.direction === 'RECEIVED' ? 'De:' : 'Para:' }}</span>
                {{ counterpartLabel(item) }}
              </p>
              <span class="shrink-0 text-xs text-gray-400 dark:text-gray-500">{{ formatRelative(item.fecha) }}</span>
            </div>
            <div class="mt-0.5 flex items-center gap-1.5">
              @if (item.direction === 'RECEIVED' && !item.read) {
              <span class="h-2 w-2 shrink-0 rounded-full bg-brand-500" title="No leído"></span>
              }
              <p class="truncate text-sm"
                 [class.text-gray-800]="item.direction === 'RECEIVED' && !item.read" [class.dark:text-gray-100]="item.direction === 'RECEIVED' && !item.read"
                 [class.font-semibold]="item.direction === 'RECEIVED' && !item.read"
                 [class.text-gray-500]="item.read" [class.dark:text-gray-400]="item.read">
                {{ item.subject || '(sin asunto)' }}
              </p>
              <!-- Chip de estado para enviados no completados (en cola / fallido) -->
              @if (showStatusChip(item)) {
              <span class="ml-auto shrink-0 rounded-full px-2 py-0.5 text-[10px] font-medium" [ngClass]="statusColor(item.status)">
                {{ statusLabel(item.status) }}
              </span>
              }
            </div>
            <!-- Badge personal/campaña (solo enviados) -->
            @if (item.direction === 'SENT') {
            <div class="mt-1">
              <span class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium"
                    [ngClass]="envioBadgeColor(item.bulk)"
                    [title]="purposeLabel(item.purpose, item.bulk)">
                @if (isBulk(item.bulk)) {
                <!-- Megáfono (campaña) -->
                <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"></path>
                </svg>
                } @else {
                <!-- Persona (personal) -->
                <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                </svg>
                }
                {{ envioBadgeLabel(item.bulk) }}
              </span>
            </div>
            }
          </div>

          <!-- Acción rápida (hover): ver conversación con la contraparte -->
          @if (item.counterpartEmail) {
          <button type="button" (click)="verConversacionItem(item, $event)"
            title="Ver conversación con esta persona"
            class="absolute bottom-2 right-3 hidden rounded-md bg-white/90 p-1.5 text-gray-400 group-hover:block hover:text-brand-500 dark:bg-gray-900/90 dark:hover:text-brand-400">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.86 9.86 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
            </svg>
          </button>
          }
        </li>
        }
      </ul>

      <!-- Cargar más (paginación page/size; oculto cuando es la última página) -->
      @if (puedeCargarMas) {
      <div class="border-t border-gray-100 p-3 text-center dark:border-gray-800">
        <button
          type="button"
          (click)="cargarMas()"
          [disabled]="loadingMore"
          class="inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium text-brand-600 hover:bg-brand-50 disabled:opacity-50 dark:text-brand-400 dark:hover:bg-brand-500/10">
          @if (loadingMore) {
          <span class="h-4 w-4 animate-spin rounded-full border-b-2 border-brand-500"></span>
          Cargando...
          } @else {
          Cargar más
          }
        </button>
      </div>
      }
      }
    </div>
  </div>

  <!-- ════════════════ Panel DERECHO: detalle (flex-1) ════════════════ -->
  <div class="flex flex-1 flex-col overflow-hidden bg-white dark:bg-gray-900"
       [class.hidden]="!selectedKey"
       [class.lg:flex]="true">

    <!-- Estado vacío -->
    @if (!selectedKey) {
    <div class="flex h-full flex-col items-center justify-center px-6 text-center">
      <svg class="mb-3 h-12 w-12 text-gray-300 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
      </svg>
      <p class="text-sm text-gray-500 dark:text-gray-400">Selecciona un correo para leerlo.</p>
    </div>
    }

    <!-- Cargando detalle -->
    @if (selectedKey && detailLoading) {
    <div class="flex h-full items-center justify-center">
      <div class="h-8 w-8 animate-spin rounded-full border-b-2 border-brand-500"></div>
      <span class="ml-3 text-sm text-gray-500 dark:text-gray-400">Abriendo correo...</span>
    </div>
    }

    <!-- Error detalle -->
    @if (selectedKey && !detailLoading && detailError) {
    <div class="p-6">
      <div class="rounded-lg border border-error-200 bg-error-50 p-4 dark:border-error-500/20 dark:bg-error-500/10">
        <p class="text-sm text-error-600 dark:text-error-400">{{ detailError }}</p>
      </div>
    </div>
    }

    <!-- ═══ Detalle RECIBIDO (desde caché BD; sin acciones IMAP en vivo) ═══ -->
    @if (receivedDetail && !detailLoading) {
    <div class="flex h-full flex-col overflow-hidden">
      <div class="shrink-0 border-b border-gray-100 px-5 py-4 dark:border-gray-800">
        <div class="flex items-start justify-between gap-3">
          <div class="flex min-w-0 items-center gap-2">
            <button type="button" (click)="cerrarDetalle()" title="Volver a la lista"
              class="shrink-0 rounded-md p-1.5 text-gray-500 hover:bg-gray-100 lg:hidden dark:hover:bg-white/[0.05]">
              <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
              </svg>
            </button>
            <span class="inline-flex items-center gap-1 rounded-full bg-blue-light-50 px-2 py-0.5 text-[11px] font-medium text-blue-light-600 dark:bg-blue-light-500/10 dark:text-blue-light-400">
              <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M11 17l-4-4m0 0l4-4m-4 4h11"></path></svg>
              Recibido
            </span>
            <h2 class="truncate text-lg font-semibold text-gray-800 dark:text-white/90">
              {{ receivedDetail.subject || '(sin asunto)' }}
            </h2>
          </div>
          <div class="flex shrink-0 items-center gap-2">
            <button type="button" (click)="responderRecibido()" title="Responder a este correo"
              class="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-brand-500 px-3 py-1.5 text-xs font-medium text-white hover:bg-brand-600">
              <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h10a5 5 0 015 5v2M3 10l6-6M3 10l6 6"></path>
              </svg>
              Responder
            </button>
            <button type="button" (click)="verConversacionDesdeDetalle()" title="Ver conversación con esta persona"
              class="inline-flex shrink-0 items-center gap-1.5 rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-600 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/[0.03]">
              <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.86 9.86 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
              </svg>
              Ver conversación
            </button>
          </div>
        </div>

        <div class="mt-3 flex items-start gap-3">
          <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-light-50 text-xs font-semibold text-blue-light-600 dark:bg-blue-light-500/10 dark:text-blue-light-400">
            {{ receivedSenderInitials(receivedDetail) }}
          </div>
          <div class="min-w-0 flex-1 text-sm">
            <p class="font-medium text-gray-800 dark:text-white/90">
              {{ receivedSenderLabel(receivedDetail) }}
              @if (receivedDetail.fromName && receivedDetail.fromEmail) {
              <span class="ml-1 font-normal text-gray-500 dark:text-gray-400">&lt;{{ receivedDetail.fromEmail }}&gt;</span>
              }
            </p>
            @if (receivedToAddresses(receivedDetail)) {
            <p class="truncate text-gray-500 dark:text-gray-400">Para: {{ receivedToAddresses(receivedDetail) }}</p>
            }
            @if (receivedCcAddresses(receivedDetail)) {
            <p class="truncate text-gray-500 dark:text-gray-400">Cc: {{ receivedCcAddresses(receivedDetail) }}</p>
            }
          </div>
          <span class="shrink-0 text-xs text-gray-400 dark:text-gray-500">{{ formatFull(receivedDetail.receivedAt) }}</span>
        </div>
      </div>

      <!-- Cuerpo (iframe sandbox seguro) -->
      <div class="flex-1 overflow-y-auto">
        @if (bodyFrameSrc) {
        <iframe [src]="bodyFrameSrc" sandbox="allow-same-origin allow-popups" title="Contenido del correo" class="h-full w-full border-0"></iframe>
        } @else if (receivedDetail.bodyText) {
        <pre class="whitespace-pre-wrap break-words px-5 py-5 font-outfit text-sm text-gray-800 dark:text-gray-200">{{ receivedDetail.bodyText }}</pre>
        } @else {
        <p class="px-5 py-5 text-sm italic text-gray-400 dark:text-gray-500">Cuerpo no disponible todavía (sincronizando)…</p>
        }
      </div>

      <!-- Adjuntos del recibido (solo metadato; sin descarga binaria en esta vista) -->
      @if (receivedDetail.hasAttachments) {
      <div class="shrink-0 border-t border-gray-100 px-5 py-4 dark:border-gray-800">
        <p class="inline-flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
          <svg class="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"></path>
          </svg>
          Este correo tiene adjuntos.
        </p>
      </div>
      }
    </div>
    }

    <!-- ═══ Detalle ENVIADO (sin marcar-leído ni papelera) ═══ -->
    @if (sentDetail && !detailLoading) {
    <div class="flex h-full flex-col overflow-hidden">
      <div class="shrink-0 border-b border-gray-100 px-5 py-4 dark:border-gray-800">
        <div class="flex items-start justify-between gap-3">
          <div class="flex min-w-0 items-center gap-2">
            <button type="button" (click)="cerrarDetalle()" title="Volver a la lista"
              class="shrink-0 rounded-md p-1.5 text-gray-500 hover:bg-gray-100 lg:hidden dark:hover:bg-white/[0.05]">
              <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
              </svg>
            </button>
            <span class="inline-flex items-center gap-1 rounded-full bg-success-50 px-2 py-0.5 text-[11px] font-medium text-success-700 dark:bg-success-500/10 dark:text-success-400">
              <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M7 17L17 7m0 0H9m8 0v8"></path></svg>
              Enviado
            </span>
            <!-- Badge personal/campaña (derivado del purpose) -->
            <span class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium"
                  [ngClass]="envioBadgeColor(isBulkPurpose(sentDetail.purpose))"
                  [title]="purposeLabel(sentDetail.purpose, isBulkPurpose(sentDetail.purpose))">
              @if (isBulkPurpose(sentDetail.purpose)) {
              <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"></path></svg>
              } @else {
              <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg>
              }
              {{ purposeLabel(sentDetail.purpose, isBulkPurpose(sentDetail.purpose)) }}
            </span>
            <h2 class="truncate text-lg font-semibold text-gray-800 dark:text-white/90">
              {{ sentDetail.subject || '(sin asunto)' }}
            </h2>
          </div>
          <button type="button" (click)="verConversacionDesdeDetalle()" title="Ver conversación con esta persona"
            class="inline-flex shrink-0 items-center gap-1.5 rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-600 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/[0.03]">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.86 9.86 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
            </svg>
            Ver conversación
          </button>
        </div>

        <div class="mt-3 flex items-start gap-3">
          <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-success-50 text-success-700 dark:bg-success-500/10 dark:text-success-400">
            <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14M12 5l7 7-7 7"></path></svg>
          </div>
          <div class="min-w-0 flex-1 text-sm">
            <p class="truncate font-medium text-gray-800 dark:text-white/90">Para: {{ sentRecipientsTo(sentDetail) }}</p>
            @if (sentRecipientsCc(sentDetail)) {
            <p class="truncate text-gray-500 dark:text-gray-400">Cc: {{ sentRecipientsCc(sentDetail) }}</p>
            }
            <div class="mt-1 flex items-center gap-2">
              <span class="rounded-full px-2 py-0.5 text-[10px] font-medium" [ngClass]="statusColor(sentDetail.status)">
                {{ statusLabel(sentDetail.status) }}
              </span>
              @if (sentDetail.status === 'FAILED' && sentDetail.errorMessage) {
              <span class="truncate text-xs text-error-500" [title]="sentDetail.errorMessage">{{ sentDetail.errorMessage }}</span>
              }
            </div>
          </div>
          <span class="shrink-0 text-xs text-gray-400 dark:text-gray-500">{{ formatFull(sentDetail.sentAt || sentDetail.createdAt) }}</span>
        </div>
      </div>

      <!-- Cuerpo (mismo iframe sandbox seguro) -->
      <div class="flex-1 overflow-y-auto">
        @if (bodyFrameSrc) {
        <iframe [src]="bodyFrameSrc" sandbox="allow-same-origin allow-popups" title="Contenido del correo" class="h-full w-full border-0"></iframe>
        } @else if (sentDetail.bodyText) {
        <pre class="whitespace-pre-wrap break-words px-5 py-5 font-outfit text-sm text-gray-800 dark:text-gray-200">{{ sentDetail.bodyText }}</pre>
        } @else {
        <p class="px-5 py-5 text-sm italic text-gray-400 dark:text-gray-500">(mensaje sin contenido)</p>
        }
      </div>

      <!-- Adjuntos del enviado (solo metadatos) -->
      @if (sentDetail.attachments.length > 0) {
      <div class="shrink-0 border-t border-gray-100 px-5 py-4 dark:border-gray-800">
        <p class="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
          Adjuntos ({{ sentDetail.attachments.length }})
        </p>
        <div class="flex flex-wrap gap-2">
          @for (att of sentDetail.attachments; track att.id) {
          <div class="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
            <svg class="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"></path>
            </svg>
            <span class="max-w-[200px] truncate">{{ att.fileName }}</span>
          </div>
          }
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>
